import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Icon from '../AppIcon';

const DashboardHeader = ({ onMenuToggle }) => {
  const navigate = useNavigate();
  const { user, organization, role, logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);

  React.useEffect(() => {
    const handleClickOutside = () => setShowUserMenu(false);
    if (showUserMenu) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [showUserMenu]);

  return (
    <header className="fixed top-0 left-0 right-0 h-16 bg-white border-b border-[#dde1f5] z-1000 flex items-center justify-between px-4 shadow-sm">
      {/* Left */}
      <div className="flex items-center space-x-4">
        <button onClick={onMenuToggle} className="lg:hidden p-2 rounded-lg hover:bg-[#f5f3ff]">
          <Icon name="Menu" size={20} className="text-gray-500" />
        </button>
        <Link to="/dashboard" className="flex items-center space-x-3">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center shadow-sm"
            style={{ background: 'linear-gradient(135deg, #5b4fcf 0%, #4a6bc4 100%)' }}>
            <Icon name="CreditCard" size={18} color="white" />
          </div>
          <span className="text-lg font-bold text-gray-900 hidden sm:block">DynamicPay</span>
        </Link>
        {organization && (
          <div className="hidden md:flex items-center space-x-2 px-3 py-1 rounded-full" style={{background:'#f5f3ff'}}>
            <Icon name="Building2" size={14} style={{color:'#5b4fcf'}} />
            <span className="text-xs font-medium" style={{color:'#5b4fcf'}}>{organization?.name || organization?.id}</span>
          </div>
        )}
      </div>
      {/* Right */}
      <div className="flex items-center space-x-3">
        {role && (
          <div className="hidden sm:flex items-center space-x-1 px-2 py-1 rounded-full" style={{background:'#f5f3ff'}}>
            <Icon name="Shield" size={12} style={{color:'#5b4fcf'}} />
            <span className="text-xs font-semibold" style={{color:'#5b4fcf'}}>{role?.name || 'User'}</span>
          </div>
        )}

        {/* User Menu */}
        <div className="relative">
          <button
            onClick={(e) => { e?.stopPropagation(); setShowUserMenu(!showUserMenu); }}
            className="flex items-center space-x-2 p-2 rounded-lg hover:bg-[#f5f3ff] transition-colors"
          >
            <div className="w-8 h-8 rounded-full flex items-center justify-center shadow-sm"
              style={{ background: 'linear-gradient(135deg, #5b4fcf 0%, #4a6bc4 100%)' }}>
              <span className="text-xs font-bold text-white">
                {user?.first_name?.[0] || user?.email_address?.[0] || 'U'}
              </span>
            </div>
            <div className="hidden md:block text-left">
              <p className="text-sm font-semibold text-gray-900">{user?.first_name || user?.email_address || 'User'}</p>
              <p className="text-xs text-gray-500">{user?.email_address}</p>
            </div>
            <Icon name="ChevronDown" size={14} className="text-gray-400 hidden md:block" />
          </button>

          {showUserMenu && (
            <div className="absolute right-0 top-12 w-56 bg-white border border-[#dde1f5] rounded-xl shadow-lg z-950 animate-fade-in">
              <div className="p-3 border-b border-[#dde1f5]">
                <p className="text-sm font-semibold text-gray-900">{user?.first_name} {user?.last_name}</p>
                <p className="text-xs text-gray-500">{user?.email_address}</p>
              </div>
              <div className="py-2">
                <Link to="/forgot-password" className="flex items-center space-x-3 px-4 py-2 text-sm text-gray-700 hover:bg-[#f5f3ff] transition-colors">
                  <Icon name="KeyRound" size={16} style={{color:'#5b4fcf'}} />
                  <span>Reset Password</span>
                </Link>
                <button
                  onClick={() => { logout(); navigate('/login'); }}
                  className="w-full flex items-center space-x-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                >
                  <Icon name="LogOut" size={16} />
                  <span>Sign Out</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
